import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHeroSection from './components/AboutHeroSection';
import WhoWeAreSection from './components/WhoWeAreSection';
import OurApproachSection from './components/OurApproachSection';
import LeadershipSection from './components/LeadershipSection';
import ManufacturingSection from './components/ManufacturingSection';
import SEOHead from '../../components/feature/SEOHead';

const AboutPage = () => {
  return (
    <>
      <SEOHead
        title="About Us - True Passage Ventures | Global Sourcing & Procurement Partner"
        description="True Passage Ventures is a global sourcing and procurement partner helping businesses identify, vet, and work with reliable manufacturing and supply partners across India and key international supply markets. Learn about our approach, leadership, and manufacturing capabilities."
        keywords="global sourcing, procurement partner, manufacturing partners, supplier vetting, CAD design, precision engineering, industrial manufacturing, True Passage Ventures"
        canonical="https://truepassage.com/about"
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <AboutHeroSection />
        <WhoWeAreSection />
        <OurApproachSection />
        <LeadershipSection />
        <ManufacturingSection />
        <Footer />
      </div>
    </>
  );
};

export default AboutPage;